import { formatDate } from "@angular/common";
import { LOCALE_ID, Pipe, Inject, PipeTransform } from "@angular/core";

const HTML_TIME_TAG_REGEXP =
	/(?:<time\s+datetime="(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z)"[^>]*?>.*?<\/time>)/gis;

@Pipe({ name: "obgOmsSummaryLocalizeTime" })
export class OmsSummaryListLocalizeTimePipe implements PipeTransform {
	constructor(@Inject(LOCALE_ID) private readonly locale: string) {}

	transform(value: string | null | undefined, format?: string, timezone?: string): string {
		if (!value) {
			return "";
		}

		return value.replace(HTML_TIME_TAG_REGEXP, (_match: string, utc: string) =>
			this.localizeTime(utc, { format, timezone })
		);
	}

	private localizeTime(value: string, options?: { format?: string; timezone?: string }): string {
		const { format = "short", timezone } = options || {};

		return formatDate(value, format, this.locale, timezone);
	}
}
